<template>
    <div v-if="editMode" class="cta__container">
       <h3 class="input__title">CTA #{{ ctaNumber }}</h3>
      <div class="cta__select">
      <label for="checkedCTA">Type</label>
      <select id="checkedCTA" v-model="CTABlock.checkedCTA" class="cta__select__dropdown">
        <option value="Link">Link</option>
        <option value="PDF">PDF</option>
        <option value="Pop Up Message">Pop Up Message</option>
      </select>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none" class="custom__arrow">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1628 6.12727L8 10.0355L4.83721 6.12727H11.1628Z" fill="#041E3A"/>
      </svg>
    </div>
       <a class="CTA__delete line__button" @click="handleCTADelete">Remove CTA</a>
    </div>
         
    <div v-if="editMode" class="inputWrapper">
      <label for="ctaText">CTA text</label>
      <input type="text" id="ctaText" name="ctaText" v-model="CTABlock.ctaText" placeholder="Enter text" class="input__text"/>
        <label for="ctaValue">CTA Value</label>

      <p class="helpermsg" v-if="CTABlock.checkedCTA === 'Link'">
          Please enter $url('Search-Show', 'cgid', 'testing')$ or $url('Account-Show')$ or <br />url path (it must be started with https:// e.g: https://google.com)
      </p>
      <p class="helpermsg" v-if="CTABlock.checkedCTA === 'PDF'">Please insert your relative folder path. For example, ‘default/content/pdf/RRL/RRLFall25Catalog.pdf’ → ‘RRL/RRLFall25Catalog.pdf’</p>
      <p class="helpermsg" v-if="CTABlock.checkedCTA === 'Pop Up Message'">Please enter $include('Page-Include','cid','testing')$ or text</p>
      <input type="text" name="text" id="ctaValue" v-model="CTABlock.ctaValue" class="input__text" placeholder="Enter value">
      <p v-if="showError" class="helpermsg" style="color: red;">Url should be started with https:// or $url</p>
    </div>
       <div v-else class="display__cta__container">
      <h3 class="display__title">CTA #{{ ctaNumber }}</h3>
      <div class="text__group">
        <h4 class="display__text">Type</h4>
        <p class="display_value">{{ CTABlock.checkedCTA }}</p>
      </div>
      <div class="text__group">
        <h4 class="display__text">CTA text</h4>
        <p class="display_value">{{ CTABlock.ctaText }}</p>
      </div>
      <div class="text__group">
        <h4 class="display__text">CTA Value</h4>
        <p class="display_value">{{ CTABlock.ctaValue }}</p>
      </div>
    </div>
</template>

<script setup>
import { ref } from "vue"
import { store } from '@/helper/store';
import { computed } from 'vue';

const props = defineProps({
    CTABlock: Object,
    editMode: Boolean,
    tickerIndex: Number,
    ctaIndex: Number,
    showError: Boolean
})

// Calculate the dynamic CTA number based on position
const ctaNumber = computed(() => {
    return props.ctaIndex + 1
})

const handleCTADelete = () => {
  for(let i =0; i<store.value.length; i++){
    for(let x =0; x<store.value[i].cta.length; x++){
      if(store.value[i].cta[x].id === props.CTABlock.id){
          store.value[i].cta.splice(x, 1)
      }
    }
  }
}

</script>


<style>

</style>